/**
 * Throttle any events.
 *
 * @author rafhun <raphael.hueni@cubetech.ch>
 * @export
 * @param {*} type Event to be throttled
 * @param {*} name Name of the new custom/throttled event
 * @param {*} obj Object or DOMElement the event is attached to
 * @see https://css-tricks.com/debouncing-throttling-explained-examples/#requestanimationframe-raf
 * @example throttle('scroll', 'optimizedScroll'); window.addEventListener('optimizedScroll', callback);
 */
export function throttle(type, name, obj) {
    obj = obj || window;
    let running = false;
    const func = () => {
        if (running) {
            return;
        }

        running = true;

        requestAnimationFrame(() => {
            obj.dispatchEvent(new CustomEvent(name));
            running = false;
        });
    };
    obj.addEventListener(type, func);
}

/**
 * This function computes the current height of the main header element.
 *
 * @author rafhun <raphael.hueni@cubetech.ch>
 * @export
 * @returns
 */
export function getHeaderHeight() {
    const header = document.querySelector('body > header');

    if (!header) {
        return;
    }

    let headerHeight = header.offsetHeight;

    const adminbar = document.querySelector('#wpadminbar');
    if (adminbar) {
        headerHeight += adminbar.offsetHeight;
    }

    return headerHeight;
}

export function isOverflown({ clientWidth, clientHeight, scrollWidth, scrollHeight }) {
    return scrollHeight > clientHeight || scrollWidth > clientWidth;
}
